import { AxiosInstance } from 'axios';
import modifyDeep from '../../../libs/modifyDeep';

function convertDateToLocalGmt(key: any, value: any) {
    
    if(value instanceof Date) {
        return new Date(value.setHours(value.getHours() - value.getTimezoneOffset() / 60))
    }
    return value;
}

const transformDateToSendToServer = (instance: AxiosInstance) => {
    instance.interceptors.request.use((value) => {
        modifyDeep(value.data, convertDateToLocalGmt);
        return value;
    });
};

export default transformDateToSendToServer;